import { useTranslation } from "react-i18next";

import { Plus, SlChillPhone } from "@/assets/icons/icons.tsx";
import { ProductCard } from "@/components/Layout/BaseLayouts/ProductCard/ProductCard";
import { ProductCardFooterItem } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardFooterItem";
import { useSectionHeadingLevel } from "@/components/Layout/BaseLayouts/SectionHeadingLevel";

const headingTag = { 2: "h2", 3: "h3" } as const;

interface AddDeviceTileProps {
  addDeviceRoute: string;
}

export const AddDeviceTile = ({ addDeviceRoute }: AddDeviceTileProps) => {
  const { t } = useTranslation("portal");
  const Heading = headingTag[useSectionHeadingLevel()];

  return (
    <ProductCard
      dataTestid="add-device-tile"
      header={
        <div className="flex h-full w-full flex-col items-start gap-3 pt-4">
          <SlChillPhone className="size-16 shrink-0" />
          <Heading className="w-full text-headline-md font-semibold leading-sm text-foreground-primary">
            {t("layout.tiles.addDevice.title")}
          </Heading>
        </div>
      }
      footer={
        <ProductCardFooterItem
          variant="button"
          label={t("layout.tiles.addDevice.button")}
          icon={<Plus />}
          to={addDeviceRoute}
        />
      }
    />
  );
};
